<div #gmapContainer id="map"></div>
<div
  id="left_div"
  [ngStyle]="{ 'width.px': leftDivStyles.x }"
  *ngIf="show_left_div != false"
>
  <div class="icons_div">
    <div class="div_icon_left">
      <tui-icon icon="tuiIconMapLarge" class="green_icon"></tui-icon>
      <p class="p_text">
        {{ "service_manager.routing_map.title" | translate }}
      </p>
    </div>
    <div class="div_icon_right" *ngIf="expandDivLeft">
      <tui-icon
        icon="tuiIconChevronLeft"
        class="black_icon p_ele"
        (click)="hideLeftDiv()"
      ></tui-icon>
      <span class="text_hide_icon" (click)="hideLeftDiv()">
        {{ "service_manager.routing_map.hide_text" | translate }}
      </span>
    </div>
    <div class="div_icon_right" *ngIf="!expandDivLeft">
      <tui-icon
        icon="tuiIconChevronRight"
        class="black_icon p_ele"
        (click)="showLeftDiv()"
      ></tui-icon>
    </div>
  </div>
  <div class="inputs_div" *ngIf="expandDivLeft">
    <div>
      <tui-input-date-range
        tuiTextfieldSize="s"
        [(ngModel)]="selectedDate"
        [tuiTextfieldCleaner]="true"
        [tuiTextfieldLabelOutside]="true"
        (ngModelChange)="onDateChange()"
      >
        {{ "POOL_MANAGER_MAP.0" | translate }}
      </tui-input-date-range>
      <br />
    </div>
    <div class="div_input_left" [formGroup]="filterForm">
      <select
        name=""
        formControlName="zoneFilter"
        id=""
        class="form-control select_form"
        [ariaPlaceholder]="'POOL_MANAGER_MAP.1' | translate"
      >
        <option value="" disabled selected hidden>
          {{ "POOL_MANAGER_MAP.1" | translate }}
        </option>
        <option *ngFor="let zone of zones" [value]="zone.zoneId">
          {{ zone.zoneName }}
        </option>
      </select>
    </div>
    <div class="div_input_right" [formGroup]="filterForm">
      <tui-input
        formControlName="mapfilter"
        class="input_form"
        id=""
        tuiTextfieldIconLeft="tuiIconSearch"
        [tuiTextfieldLabelOutside]="true"
        (input)="filterData($event)"
      >
        {{
          selectedItemFilter == "services"
            ? ("POOL_MANAGER_MAP.2" | translate)
            : ("POOL_MANAGER_MAP.3" | translate)
        }}
      </tui-input>
    </div>
  </div>
  <div class="buttons_div">
    <button
      tuiButton
      type="button"
      [ngClass]="{ active_item: selectedItemFilter == 'services' }"
      class="tui-space_right-3 tui-space_bottom-3 btn_item"
      size="m"
      appearance="secondary"
      (click)="changeSelectedItemFilter('services')"
    >
      <span *ngIf="expandDivLeft">
        {{ "POOL_MANAGER_MAP.4" | translate }} ({{ filtered_services.length }})
      </span>
      <span *ngIf="!expandDivLeft">
        <tui-svg src="tuiIconGitCommit"></tui-svg> ({{
          filtered_services.length
        }})
      </span>
    </button>
    <button
      tuiButton
      type="button"
      [ngClass]="{ active_item: selectedItemFilter == 'drivers' }"
      class="tui-space_right-3 tui-space_bottom-3 btn_item"
      size="m"
      appearance="secondary"
      (click)="changeSelectedItemFilter('drivers')"
    >
      <span *ngIf="expandDivLeft">
        {{ "service_manager.routing_map.drivers_services" | translate }} ({{
          filtered_drivers.length
        }})
      </span>
      <span *ngIf="!expandDivLeft">
        <tui-svg src="tuiIconUser"></tui-svg> ({{ filtered_drivers.length }})
      </span>
    </button>
  </div>
  <hr />
  <div class="div_elements_body" *ngIf="expandDivLeft">
    <div
      id="list_services"
      class="g_div"
      *ngIf="selectedItemFilter == 'services'"
    >
      <div
        class="item_list_service l_item"
        *ngFor="let service of filtered_services"
      >
        <div
          class="card-header"
          style="display: flex; align-items: center; gap: 10px"
        >
          <div class="info-title-row inf_ele">
            <p>
              <b>{{ hs.translate(service.productName) }}</b>
            </p>

            <tui-badge
              status="success"
              [value]="'POOL_MANAGER_MAP.5' | translate"
              class="tui-space_right-2 tui-space_bottom-2 ml-5"
              *ngIf="service?.driverGuid"
            ></tui-badge>
            <tui-badge
              status="error"
              [value]="'POOL_MANAGER_MAP.6' | translate"
              class="tui-space_right-2 tui-space_bottom-2 ml-5"
              *ngIf="!service?.driverGuid"
            ></tui-badge>
          </div>

          <div class="inf_ele info-licenseplate-row">
            <p style="margin: 0px">
              {{ service.licensePlate }}
              {{ getTypeChassisByType(service.vehicleType) }}
            </p>
          </div>
        </div>

        <div style="padding: 10px 0px 5px 15px">
          <tui-svg src="tuiIconCalendar"></tui-svg>
          {{ service.serviceDateOnly }} <tui-svg src="tuiIconClock"></tui-svg>
          {{ service.serviceHour }}
        </div>

        <div class="bottom_left_info_service inf_ele pld">
          <p>
            <tui-svg src="tuiIconMapPin"></tui-svg>
            {{ service.startUbication.address }}
          </p>
        </div>
        <div
          class="bottom_right_info_service inf_ele prd"
          (click)="setActiveService(service, service.driverGuid)"
        >
          <p>
            <b>
              {{ "service_manager.routing_map.more_info_text" | translate }}
              <tui-svg src="tuiIconChevronDown"></tui-svg>
            </b>
          </p>
        </div>
      </div>
    </div>
    <div
      id="list_drivers"
      class="g_div"
      *ngIf="selectedItemFilter == 'drivers'"
    >
      <div *ngFor="let driver of filtered_drivers">
        <div
          class="item_list_driver l_item"
          *ngIf="driver?.fullName && driver?.isActive"
          (click)="focusDriverMap(driver, false)"
          style="cursor: pointer"
        >
          <div class="photo_user">
            <div class="avatar_user" style="background-color: #999"></div>
          </div>
          <div class="info_user_driver">
            <div class="top_lef_info_driver">
              <p>
                {{ driver?.fullName }}
              </p>
            </div>
            <div class="top_right_info_driver prd">
              <p>
                <span>
                  {{ getRoleInfo(driver?.operatorType ?? "") }}
                </span>
              </p>
            </div>
            <div class="bottom_left_info_driver">
              <p>
                <!-- {{ driver.placa }} -->
                <tui-badge
                  status="success"
                  [value]="'POOL_MANAGER_MAP.7' | translate"
                  class="tui-space_right-2 tui-space_bottom-2 ml-5"
                  *ngIf="driver?.isActive"
                ></tui-badge>
                <tui-badge
                  status="error"
                  [value]="'POOL_MANAGER_MAP.8' | translate"
                  class="tui-space_right-2 tui-space_bottom-2 ml-5"
                  *ngIf="!driver?.isActive"
                ></tui-badge>
              </p>
            </div>
            <div class="bottom_right_info_driver">
              <p>
                {{ "POOL_MANAGER_MAP.12" | translate }}
                {{ driver.contactPhoneNumber }}
              </p>
            </div>
          </div>
          <div class="more_info_driver" *ngIf="driver.serviceAssigned">
            <tui-svg
              src="tuiIconChevronDown"
              class="icon_more_info_driver"
            ></tui-svg>
          </div>

          <div
            *ngIf="showDriverServicesId == driver.driverId"
            class="box_services_all"
            (click)="$event.stopPropagation()"
          >
            <div *ngIf="driverServices.length > 0">
              <div *ngFor="let ser of driverServices">
                <div
                  class="box_services"
                  (click)="setActiveService(ser, driver.driverId)"
                >
                  <div class="box_services_name">
                    <p>
                      <b>{{ hs.translate(ser.productName) }}</b>
                      {{ ser.licensePlate }} <br />
                      <tui-svg src="tuiIconClock"></tui-svg>
                      {{
                        ser.serviceDate | timezoneDate : "DD-MM-YYYY HH:mm z"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div id="left_div2" *ngIf="!show_left_div">
  <div class="icons_div">
    <div class="div_icon_left2">
      <tui-icon
        icon="tuiIconChevronLeft"
        class="black_icon p_ele"
        (click)="backToMap()"
      ></tui-icon>
      <span class="text_hide_icon" (click)="backToMap()">
        {{ "service_manager.routing_map.back_map" | translate }}
      </span>
    </div>
  </div>
  <div class="row p_25">
    <div class="col">
      <br />
      <h2 class="fs_24">
        {{ hs.translate(active_detail_service?.productName ?? "") }}
      </h2>
      <p class="p_fs_13">
        {{ active_detail_service?.licensePlate }}
      </p>
      <p class="p_fs_13">Order hash {{ active_detail_service?.orderHash }}</p>
      <p class="p_fs_13">
        {{ getTypeChassisByType(active_detail_service?.vehicleType) }}
      </p>
    </div>
  </div>
  <div class="row p_25">
    <div class="col">
      <p class="p_fs_13 mb_5">
        <b
          >{{
            "service_manager.routing_map.detail_service_client" | translate
          }}:</b
        >
        {{
          client_info
            ? client_info?.businessName
            : active_detail_service?.clientName
        }}
      </p>

      <p class="p_fs_13 mb_5">
        <b
          >{{
            "service_manager.routing_map.detail_service_pickup_ponit"
              | translate
          }}:</b
        >
        {{ active_detail_service?.startUbication?.address }}
      </p>
      <p class="p_fs_13 mb_5" *ngIf="active_detail_service?.serviceDate">
        <b>{{ "POOL_MANAGER_MAP.10" | translate }}</b>
        {{ active_detail_service?.serviceDate }}
      </p>

      <p class="p_fs_13 mb_5">
        <b
          >{{
            "service_manager.routing_map.detail_service_delivery_ponit"
              | translate
          }}:</b
        >
        {{ active_detail_service?.endUbication?.address }}
      </p>
    </div>
  </div>

  <ng-container *ngIf="active_desasign_driver">
    <hr />
    <p class="p_fs_13 mb_5" style="padding: 0px 20px 10px">
      {{ "POOL_MANAGER_MAP.11" | translate }}
    </p>

    <div class="div_drivers_scrol2l" style="padding-top: 10px">
      <div
        style="cursor: pointer"
        (click)="focusDriverMap(active_desasign_driver, false)"
      >
        <div class="photo_user">
          <div class="avatar_user" style="background-color: #999"></div>
        </div>
        <div class="info_user_driver">
          <div class="top_lef_info_driver">
            <p>
              {{ active_desasign_driver.fullName }}
            </p>
          </div>
          <div class="top_right_info_driver prd">
            <p>
              <span>
                {{ getRoleInfo(active_desasign_driver.operatorType) }}
              </span>
            </p>
          </div>
          <div class="bottom_left_info_driver">
            <p>
              <!-- {{ active_desasign_driver.placa }} -->
              <tui-badge
                status="success"
                [value]="'POOL_MANAGER_MAP.7' | translate"
                class="tui-space_right-2 tui-space_bottom-2 ml-5"
                *ngIf="active_desasign_driver?.isActive"
              ></tui-badge>
              <tui-badge
                status="error"
                [value]="'POOL_MANAGER_MAP.8' | translate"
                class="tui-space_right-2 tui-space_bottom-2 ml-5"
                *ngIf="!active_desasign_driver?.isActive"
              ></tui-badge>
            </p>
          </div>
          <div class="bottom_right_info_driver">
            <p>
              {{ "POOL_MANAGER_MAP.8" | translate }}
              {{ active_desasign_driver.contactPhoneNumber }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="!active_desasign_driver">
    <hr />
    <p class="p_fs_13 mb_5" style="padding: 0px 20px 10px">
      {{ "POOL_MANAGER_MAP.13" | translate }}
    </p>
  </ng-container>
</div>
